import $ from 'jquery';
import FloatLabels from 'float-labels.js';
import tippy from 'tippy.js';
import iFrameResize from 'iframe-resizer/js/iframeResizer';



const stickyHeight = 60;


/* IE classes
********************************************/

let isIE = false;
if (/MSIE 10/i.test(navigator.userAgent)) {
	isIE = true;
	$('html').addClass('ie ie-10');
}
if (/rv:11.0/i.test(navigator.userAgent)) {
	isIE = true;
	$('html').addClass('ie ie-11');
}


/* Smooth scroll
********************************************/

$('a[href*="#"]:not([href="#"])').on('click', function () {
	var $this = $(this);
	if ($this.closest('.js-no-smooth-scroll').length == 0 && $this.parents('.js-tabs-nav').length == 0) {
		if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
			var target = $(this.hash);

			if ( target.length && target.hasClass( 'js-gallery-modal' ) ) {
				// this is a gallery modal button/link, don't smooth scroll this
				return;
			}

			target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
			if (target.length) {
				$('html, body').animate({
					scrollTop: target.offset().top - stickyHeight + 1
				}, 500);
				return false;
			}
		}
	}
});



/* Tables
********************************************/

if ($('table').length) {
	$('table').wrap('<div class="c-table-wrapper"></div>');
}


/* Floating labels
********************************************/

new FloatLabels( '.js-float-labels', {});



/* Form groups
********************************************/

if ($('.js-form-group').length) {
	$('.js-form-group').on('click', function (e) {
		// e.preventDefault();
		$(this).addClass('is-active');
		if (!$(e.target).closest('.js-form-group .c-form-element').length) {
			$('.js-form-group .c-form-element__field input').trigger('focus');
		}
	});

	$(document).on('click', function (e) {
		if (!$(e.target).closest('.js-form-group').length) {
			$('.js-form-group').removeClass('is-active');
		}
	});
}



/* Select
********************************************/

$("select").on('change', function () {
	if($(this).val() == "") $(this).addClass("c-placeholder");
	else $(this).removeClass("c-placeholder")
});
$("select").trigger('change');



/* Select
********************************************/

$( '.js-number-input .c-number-input__button--remove' ).on( 'click', function() {
	$( this ).parents( '.js-number-input' ).find( 'input[ type="number" ]' )[ 0 ].stepDown();
} );

$( '.js-number-input .c-number-input__button--add' ).on( 'click', function() {
	$( this ).parents( '.js-number-input' ).find( 'input[ type="number" ]' )[ 0 ].stepUp();
} );



/* Dropdowns
********************************************/

if ($('.js-dropdown').length) {
	$('.js-dropdown-toggle').on('click', function (e) {
		e.preventDefault();
		$(this).closest('.js-dropdown').toggleClass('has-dropdown-open');
	});

	$(document).on('click', function (e) {
		if (!$(e.target).closest('.js-dropdown').length) {
			$('.js-dropdown').removeClass('has-dropdown-open');
		}
	});
}



/* iOS vieport fix
********************************************/

window.onresize = function() {
	var windowHeight = window.innerHeight;
	document.body.height = windowHeight;
	$(".c-offcanvas").css("height", windowHeight);
}
window.onresize(); // called to initially set the height.



/* Tooltips
********************************************/

/**
 * https://atomiks.github.io/tippyjs/v6/all-props/
 */
tippy('[data-tippy-content]', {
	allowHTML: true,
	interactive: true, // TODO (@tomislav): this is useful while styling, turn off after?
});



/* iFrameResize
********************************************/

iFrameResize( {}, '.js-purchase-order-lookup-iframe' );



// https://designstudiobath.com/commercial/evolution/try/ tracking

if ( window.location.pathname.toLowerCase() === '/commercial/evolution/try/' ) {
	$( document ).on( 'click', '#gform_submit_button_12', function() {
		if ( window.lintrk ) {
			window.lintrk( 'track', { conversion_id: 4454626 } );
		}
	} );
}
